module.exports = __webpack_public_path__ + "img/ccurl_gallery_logo.ecf14799.svg";